import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing custom components
import { IconButton } from '../core/icon-button';
// Importing hooks
import { useDate } from '../../hooks/use-date';
import { useShallow } from 'zustand/react/shallow';
// Importing icons
import ReplayIcon from '@mui/icons-material/ReplayRounded';
// Importing store
import { usePostStore } from '../../store/post.store';
// Importing 3rd party components
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// Importing 3rd party dependencies
import { Fragment } from 'react';
// ----------------------------------------------------------------------
export const EndScreen = (props) => {
    // Adding hooks
    const { formatDate } = useDate();
    // Adding post store
    const { post } = usePostStore(useShallow((state) => ({
        post: state.post,
    })));
    return (_jsxs(Fragment, { children: [_jsx(Stack, { alignItems: "center", height: '100%', justifyContent: "center", display: { xs: 'none', sm: 'flex' }, children: _jsx(IconButton, { "aria-label": "play", sx: {
                        animation: 'playIconFadeUp 0.125s forwards',
                        '@keyframes playIconFadeUp': {
                            '0%': { opacity: 0, scale: 3, transform: 'translate(0%,100%)' },
                            '100%': { opacity: 1, scale: 1, transform: 'translate(0%,0%)' },
                        },
                    }, children: _jsx(ReplayIcon, { fontSize: "xxlarge" }) }) }), _jsx(Grid, { item: true, top: 0, position: "absolute", width: "100%", children: _jsx(Grid, { container: true, paddingInline: 4, pt: 4, children: _jsx(Grid, { item: true, display: { xs: 'none', sm: 'flex' }, xs: 6, children: post && (_jsxs(Grid, { container: true, spacing: 2, alignItems: 'center', children: [_jsx(Grid, { item: true, xs: 3, children: _jsx(Box, { component: 'img', src: post.thumbnail, sx: {
                                            border: 2,
                                            borderStyle: 'solid',
                                            borderRadius: 2,
                                            borderColor: 'white',
                                            maxWidth: '150px',
                                            width: '100%',
                                        } }) }), _jsxs(Grid, { item: true, xs: 9, children: [_jsx(Typography, { color: "white", maxWidth: '80%', noWrap: true, variant: "h6", children: post.title }), _jsx(Typography, { color: "white", maxWidth: '90%', noWrap: true, variant: "body2", children: post.teaser }), _jsx(Typography, { color: "white", maxWidth: '90%', noWrap: true, variant: "body2", children: formatDate(post.date) })] })] })) }) }) })] }));
};
